// components/MultiGymSettingsModal.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import {
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBBtn,
    MDBContainer,
    MDBCard,
    MDBCardBody,
    MDBCardHeader,
    MDBInput,
    MDBCheckbox,
    MDBSwitch,
    MDBCardFooter,
} from "mdb-react-ui-kit";
import { multiGymSettingSave } from "../services/apiServices";
import { useAnalytics } from '../hooks/useAnalytics';


const MultiGymSettingsModal = ({ open, setOpen, gyms, globalPlans, onSave, savedSettings }) => {
    const [overrides, setOverrides] = useState([]);
    const homeGymId = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;
    const { trackButtonClick } = useAnalytics();
    // Initialize overrides with saved settings or defaults - FIXED VERSION
    useEffect(() => {
        if (gyms?.length) {


            const initialOverrides = gyms.map((gym) => {
                // Skip home gym for overrides
                if (gym._id.toString() === homeGymId.toString()) return null;

                // Find saved override for this gym
                const savedOverride = savedSettings?.overrides?.find(
                    ov => ov.gymId.toString() === gym._id.toString()
                );

                console.log(`Gym: ${gym.businessName}, Saved override:`, savedOverride);

                // If we have saved settings, use them exactly as saved
                if (savedOverride) {
                    return {
                        gymId: gym._id,
                        gymName: gym.businessName || "",
                        active: savedOverride.active,
                        allowedPlans: savedOverride.allowedPlans || [], // Use exactly what's saved
                        notes: savedOverride.notes || "",
                    };
                } else {
                    // If no saved settings, use default (all plans allowed)
                    return {
                        gymId: gym._id,
                        gymName: gym.businessName || "",
                        active: true,
                        allowedPlans: globalPlans.map(p => p._id),
                        notes: "",
                    };
                }
            }).filter(Boolean);

            // console.log("Final overrides:", initialOverrides);
            setOverrides(initialOverrides);
        }
    }, [gyms, globalPlans, savedSettings, homeGymId]);

    const toggleActive = (gymId) => {
        setOverrides((prev) =>
            prev.map((o) =>
                o.gymId === gymId ? { ...o, active: !o.active } : o
            )
        );
    };

    const togglePlan = (gymId, planId) => {
        setOverrides((prev) =>
            prev.map((o) =>
                o.gymId === gymId
                    ? {
                        ...o,
                        allowedPlans: o.allowedPlans.includes(planId)
                            ? o.allowedPlans.filter((id) => id !== planId)
                            : [...o.allowedPlans, planId],
                    }
                    : o
            )
        );
    };

    const updateNotes = (gymId, value) => {
        setOverrides((prev) =>
            prev.map((o) => (o.gymId === gymId ? { ...o, notes: value } : o))
        );
    };

    const handleSave = async () => {


        const payload = {
            homeGym: homeGymId,
            globalPlans: globalPlans.map((p) => p._id),
            overrides: overrides,
        };


        try {
            const res = await multiGymSettingSave(payload);
            // console.log(res)

            if (onSave) onSave(res?.data);
            setOpen(false);
            await trackButtonClick("MultiGymSetting", "Updated_Partner_Gym_Settings", "staff", {});

            alert("Settings saved successfully!");
        } catch (err) {
            console.error("Error saving overrides:", err);
            alert("Failed to save settings, please try again.");
        }
    };

    const handleClose = () => {
        setOpen(false);
    };


    return (
        <MDBModal open={open} setOpen={setOpen} show={open} tabIndex="-1" size="lg">
            <MDBModalDialog size="fullscreen-md-down">
                <MDBModalContent>
                    <MDBModalHeader>
                        <MDBModalTitle>Check-in Settings</MDBModalTitle>
                        <MDBBtn className="btn-close" color="none" onClick={handleClose} />

                    </MDBModalHeader>
                    <MDBModalBody className="p-2">
                        {/* <MDBCardHeader>
                                    <h5 className="mb-0">Per-Partner Overrides</h5>
                                    <small className="text-muted">
                                        Only checked plans will be allowed for partner gym check-ins
                                    </small>
                                </MDBCardHeader> */}

                        {overrides.length === 0 ? (
                            <p className="text-muted">No partner gyms available for configuration.</p>
                        ) : (
                            overrides.map((override) => (
                                <MDBCard key={override.gymId} className="mb-3 border">
                                    <MDBCardHeader className="d-flex justify-content-between align-items-center">
                                        <h6 className="mb-0">{override.gymName}</h6>
                                        <div className="d-flex align-items-center gap-2">
                                            <small className={override.active ? "text-success" : "text-danger"}>
                                                {override.active ? "Active" : "Paused"}
                                            </small>

                                            <label className="switch">
                                                <input className="form-control" type="checkbox" checked={override.active} onChange={() => toggleActive(override.gymId)} />
                                                <span className="slider round"></span>
                                            </label>

                                        </div>
                                    </MDBCardHeader>
                                    <MDBCardBody>
                                        <div className=" p-3">
                                            <div className="d-flex justify-content-between">
                                                <div>
                                                    <h6 className="m-0">Allowed Plans</h6>
                                                    <small className="text-muted">
                                                        {override.active
                                                            ? "Select which plans are allowed for this partner gym"
                                                            : "Activate this gym to configure allowed plans"
                                                        }
                                                    </small>
                                                </div>
                                                <div className="">
                                                    <small>
                                                        <span className="text-muted"> Accessed Plans:</span> <b> {override.allowedPlans.length} of {globalPlans.length} </b>
                                                    </small>
                                                </div>
                                            </div>


                                            <div className="mt-2">
                                                {globalPlans.map((plan) => {
                                                    const planId = plan._id;
                                                    const displayName = plan.isVariation
                                                        ? `${plan.baseplan?.name || ""}-${plan.name}`
                                                        : plan.name;

                                                    // CRITICAL FIX: Check if this plan ID is in allowedPlans
                                                    const isChecked = override.allowedPlans.some(
                                                        allowedPlanId => allowedPlanId.toString() === planId.toString()
                                                    );

                                                    // console.log(`Plan: ${displayName}, Checked: ${isChecked}, AllowedPlans:`, override.allowedPlans);

                                                    return (
                                                        <MDBCheckbox
                                                            key={planId}
                                                            label={displayName}
                                                            checked={isChecked}
                                                            onChange={() => togglePlan(override.gymId, planId)}
                                                            disabled={!override.active}
                                                            className="mb-2 d-block"
                                                        />
                                                    );
                                                })}
                                            </div>

                                            <div className="mt-3">
                                                <h6>Staff Notes</h6>
                                                <MDBInput
                                                    placeholder="e.g., Only valid Mon–Fri, Pool excluded"
                                                    value={override.notes}
                                                    onChange={(e) => updateNotes(override.gymId, e.target.value)}
                                                    disabled={!override.active}
                                                />
                                            </div>

                                        </div>

                                    </MDBCardBody>
                                </MDBCard>
                            ))
                        )}
                    </MDBModalBody>
                    <MDBCardFooter>
                        <div className="d-flex gap-2 justify-content-end">
                            <MDBBtn color="secondary" outline onClick={handleClose}>
                                Cancel
                            </MDBBtn>
                            <MDBBtn color="primary" onClick={handleSave}>
                                Save Settings
                            </MDBBtn>
                        </div>
                    </MDBCardFooter>
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
    );
};

export default MultiGymSettingsModal;